/* eslint-disable no-unused-vars */
import { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'dva';
import { useLocation, history } from 'umi';
import qs from 'qs';
import classnames from 'classnames';
import dayjs from 'dayjs';
import SearchGroup from './components/search_group/SearchGroup';
import TablePage from './components/table_page/TablePage';
import ButtonML from '@/components/button_ml/ButtonML';
import ModalML from '@/components/modal_ml/ModalML';
import ActionBtnGroup from './components/action_group/ActionBtnGroup';
import IndexStyled from './IndexStyled.jsx';

const GoodsManagement = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const searchRef = useRef();
  const [isSearch, setIsSearch] = useState(false);
  const { query, pathname } = location;
  // 结构到所有查询条件，包括分页条件
  const { id, title, refreshTime, pageNum = '1', pageSize = '10' } = query;

  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['giftManagement/getGoodsList'];
  const queryShelfList = useSelector(
    (state) => state.goodsShelfManagement.queryShelfList,
  );

  const [memberInfo, setMemberInfo] = useState({});

  const [column, setColumn] = useState();
  const [sort, setSort] = useState();

  // 查询事件处理
  const handleSearch = (newParam) => {
    setIsSearch(true);
    const time = dayjs().format('YYYY-MM-DD HH:mm:ss');
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParam,
        refreshTime: time,
        pageSize,
        pageNum: 1,
      })}`,
    );
  };

  // 翻页事件处理
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
      })}`,
    );
  };

  // 重置事件处理
  const handleRestClick = (rs) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
        pageSize: 10,
        pageNum: 1,
      })}`,
    );
  };

  //选择多个table
  const onSelect = () => {
    // setIdArr(val);
  };

  // 获取礼品管理列表
  const fetchData = useCallback(() => {
    const values = {
      id,
      title,
      refreshTime,
      pageNum,
      pageSize,
    };
    if (isSearch) {
      window.NE_DAWN.trigger(searchRef.current, {
        event: '_ec', // 事件名
        params: { ...values }, // 事件公参
      });
    }
    setIsSearch(false);
    dispatch({
      type: 'goodsShelfManagement/getQueryShelfList',
      payload: {
        values,
      },
    });
  }, [dispatch, id, pageNum, pageSize, title, refreshTime]);

  // 发起请求
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // //获取门店树形结构
  // const fetchStoreTreeList = useCallback(() => {
  //   dispatch({
  //     type: 'storeAnalysis/getStoreTreeList',
  //     payload: {
  //       values: {},
  //     },
  //   });
  // }, [dispatch]);
  // useEffect(() => {
  //   fetchStoreTreeList();
  // }, [fetchStoreTreeList]);

  return (
    <IndexStyled>
      <div
        data-log={JSON.stringify({
          oid: 'page_point_mall_shelf_management_list',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
        className="mm_content"
      >
        <div className={classnames('search_group', 'single_component1')}>
          <SearchGroup
            searchRef={searchRef}
            query={query}
            handleSearch={(par) => handleSearch(par)}
            restClick={handleRestClick}
          />
        </div>
        <ActionBtnGroup />
        <TablePage dataList={queryShelfList} />
      </div>
    </IndexStyled>
  );
};

export default GoodsManagement;
